import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import SearchDialog from "./dialogs/SearchDialog";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import i18n, { updateLanguageFromOffice } from "../i18n";


/* global document, Office, module, require */

const title = "Contoso Task Pane Add-in";

const rootElement = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  // 在 Office 準備好後更新語言設定
  updateLanguageFromOffice();
  
  const params = new URLSearchParams(window.location.search);
  const isSearchDialog = params.get("dialog") === "search";

  const content = isSearchDialog ? <SearchDialog /> : <App title={title} />;

  root?.render(
    <FluentProvider theme={webLightTheme}>
      {content}
    </FluentProvider>
  );
});

if (module.hot) {
  module.hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
